import "./microChipList.scss"

interface IMicroChip {
    data: ILanguagesToTeach
}

interface ILanguagesToTeach{
    language: string;
    proficiency: string;
}

export default function MicroChip({ data: { language, proficiency } }: IMicroChip) {

    const proficiencyClassName = `microChip ${proficiency}`
    
    return (


        <div className="languages-to-teach-wrapper">
            <div className="languages-to-teach">
                <div>{language} </div>
                <div className={proficiencyClassName}>
                    {proficiency}
                </div>
            </div>
        </div>


    )
}